export const pins = {
    coords: [[10, 2, -318], [12, 2, -318], [14, 2, -318], [16, 2, -318], [18, 2, -318], [12, 2, -316], [14, 2, -316], [16, 2, -316], [14, 2, -314]]
}